const defaultState = {
    item: null,
    items: [],
    total: 0,
    page: 1,
    isLoading: false,
    isLoadingSingle: false,
    isSaving: false,
    isRemoving: false,
    error: null,
}

const getters = {
    item(state) {
        return state.item;
    },
    items(state) {
        return state.items;
    },
    total(state) {
        return state.total;
    },
    isLoading(state) {
        return state.isLoading;
    },
    isLoadingSingle(state) {
        return state.isLoadingSingle;
    },
    isSaving(state) {
        return state.isSaving;
    },
    isRemoving(state) {
        return state.isRemoving;
    },
    error(state) {
        return state.error;
    },
}
const mutations = {
    item(state, item) {
        state.item = item;
    },
    items(state, items) {
        state.items = items;
    },
    total(state, total) {
        state.total = total;
    },
    isLoading(state, isLoading) {
        state.isLoading = isLoading;
    },
    isLoadingSingle(state, isLoadingSingle) {
        state.isLoadingSingle = isLoadingSingle;
    },
    isSaving(state, isSaving) {
        state.isSaving = isSaving;
    },
    isRemoving(state, isRemoving) {
        state.isRemoving = isRemoving;
    },
    error(state, error) {
        state.error = error;
    },
    clearState(state) {
        state.item = null;
        state.items = [];
        state.total = 0;
        state.page = 1;
        state.isLoading = false;
        state.isLoadingSingle = false;
        state.isSaving = false;
        state.isRemoving = false;
        state.error = null;
    }
}

module.exports = {defaultState, getters, mutations};